<template>
    <div class="container">
        <van-nav-bar title="虚拟充值" left-text="" right-text="" left-arrow @click-left="onClickLeft">
        </van-nav-bar>

        <div v-if="!isSaveSucess">
            <div class="list">
                <div class="item">
                    <van-field class="text" readonly clickable :value="communityName" placeholder="请选择用户所在项目"
                        @click="showPicker" />
                    <img class="icon" src="../assets/img/arrow_down.png" alt="">
                </div>
                <div class="item">
                    <van-field class="text" readonly clickable :value="productType" placeholder="请选择充值账户类型"
                        @click="showPicker2" />
                    <img class="icon" src="../assets/img/arrow_down.png" alt="">
                </div>
                <div class="item">
                    <van-field class="text" v-model="mobile" type="digit" placeholder="请输入被充值用户手机号" />
                </div>
                <div class="item">
                    <van-field class="text" v-model="amount" type="number" placeholder="请输入虚拟充值的金额大小"
                        @keyup="handlePrice" />
                </div>
                <div class="item">
                    <van-field class="text" v-model="remark" placeholder="备注虚拟充值的用途" />
                </div>
            </div>

            <van-popup v-model="showPopup" round position="bottom">
                <pickerEx :pickerObj="pickerObj" :columns="columns" @fromChild="pickerSelect"
                    @hidePopup=" showPopup = false" @onSearch="onSearch"></pickerEx>
            </van-popup>
            <van-popup v-model="showPopup2" round position="bottom">
                <van-picker show-toolbar :columns="productTypes" value-key="name" @cancel="showPopup2 = false"
                    @confirm="onConfirm2" />
            </van-popup>
        </div>
        <div v-else>
            <div class="detail">
                <div class="item">
                    <span>所属项目</span>
                    <span>{{ communityName }}</span>
                </div>
                <div class="item">
                    <span>账户类型</span>
                    <span>{{ productType }}</span>
                </div>
                <div class="item">
                    <span>到账手机</span>
                    <span>{{ mobile }}</span>
                </div>
                <div class="item">
                    <span>充值金额</span>
                    <span>{{ amount }}元</span>
                </div>
                <div class="item">
                    <span>备注说明</span>
                    <span>{{ remark }}</span>
                </div>
            </div>

        </div>
        <div class="next">
            <van-button class="btn" round block @click="onClickRight">
                {{ btnText }}
            </van-button>
        </div>
    </div>
</template>
  
<script>
import axios from '@/axios.js';
import config from '@/config.js'
import { NavBar, Icon, Image, Toast, Loading, Picker, Field, Popup, List, Button } from 'vant';
import pickerEx from "../components/pickerEx.vue"
export default {
    data() {
        return {
            isSaveSucess: false,
            btnText: "下一步",
            isEnable: true,

            showPopup: false,
            showPopup2: false,

            communityName: '',
            communityId: '',

            communityList: [],
            columns: [],

            productType: "",
            productTypeId: "",
            productTypes: [],
            mobile: "",
            amount: "",
            remark: "",

            pickerObj: {
                isShow: false,
                placeholder: '请选择',
                type: 'text',
                thisValue: '',  // 这个值用来返显
            },


        };
    },
    components: {
        [NavBar.name]: NavBar,
        [Icon.name]: Icon,
        [Image.name]: Image,
        [Toast.name]: Toast,
        [Loading.name]: Loading,
        [Field.name]: Field,
        [Picker.name]: Picker,
        [Popup.name]: Popup,
        [Button.name]: Button,
        [List.name]: List,
        pickerEx
    },
    methods: {
        onClickLeft() {
            this.$router.go(-1);
        },
        onClickRight() {
            if (!this.isEnable) {
                return;
            }
            if (this.isSaveSucess) {
                this.onClickLeft();
            } else {
                if (!this.communityId) {
                    Toast('请选择项目');
                    return;
                } else if (!this.productType) {
                    Toast('请选择充值账户类型');
                    return;
                } else if (!this.mobile) {
                    Toast('请输入被充值用户手机号');
                    return;
                } else if (!this.amount) {
                    Toast('请输入虚拟充值的金额大小');
                    return;
                } else {
                    this.isEnable = false;
                    let path = "";
                    if(this.productTypeId==1){
                        path = config.API.BaseURL2 + "/cardamountimport/createbyoperation";
                    } else {
                        path = "/recharge/create";
                    }
                    axios.post(path, {
                        communityId: this.communityId,
                        productType: this.productTypeId,
                        details: [{
                            mobile: this.mobile,
                            amount: parseInt(this.amount * 100),
                            remark: this.remark,
                        }]

                    }).then((res) => {
                        this.isEnable = true;
                        if (res.isSuccess) {
                            Toast('创建成功');
                            this.isSaveSucess = true;
                            this.btnText = "完成";
                            // this.$router.replace({ path: "constructionList.html" });
                        }
                    }).catch(e => {
                        this.isEnable = true;
                    });

                }
            }
        },
        handlePrice(e) {
            e.target.value = e.target.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
            this.amount = e.target.value;
        },

        //项目选中回调
        pickerSelect(val, index) {
            console.log(index)
            this.showPopup = false;

            this.communityId = this.communityList[index[0]].communitys[index[1]].id;
            this.communityName = val[1];
            console.log(this.communityId + "   " + this.communityName);
        },

        onSearch(keyword) {
            //调用接口筛选
            this.getCommunityList(keyword);
        },

        //选择项目
        showPicker() {
            this.pickerObj.isShow = true;
            this.showPopup = true;
        },
        getCommunityList(keyword) {
            axios.get("/community/citywithcommunitylist?communityName=" + keyword,
            ).then((res) => {
                this.communityList = res.data;
                if (this.communityList && this.communityList.length > 0) {
                    this.columns = this.communityList.map(item => {
                        return {
                            name: item.cityName,
                            children: item.communitys
                        }
                    })
                } else {
                    this.columns = [];
                }
            })

        },
        //选择账户类型
        getRechargeType() {
            this.productTypes = [
                {
                    id: 0,
                    name: "非机动车账户",
                },
                {
                    id: 1,
                    name: "机动车账户",
                },

            ];
        },
        showPicker2() {
            this.showPopup2 = true;
        },

        onConfirm2(item) {
            this.productType = item.name;
            this.productTypeId = item.id;
            this.showPopup2 = false;
        },
    },
    computed: {
    },
    created() {
        this.getCommunityList("");
        this.getRechargeType();
    },
    mounted() { },
    destroyed() { }
}
</script>
<style lang="less" scoped>
body,
html {
    width: 100%;
    height: 100%;
    background: #F5F6F7;
}

.container {
    width: 100%;
    height: 100%;
    letter-spacing: 0px;
    background: #F5F6F7;
    box-sizing: border-box;
}

.list {
    width: 100%;
    height: auto;
    padding: 17px 32px 0 32px;
    line-height: 54px;
    text-align: center;
    box-sizing: border-box;

    .item {
        width: 100%;
        padding: 5px 12px;
        display: flex;

        background: #FFFFFF;
        border-radius: 20px;
        margin-bottom: 20px;
        vertical-align: middle;
        align-items: center;
        justify-content: center;

        .text {
            width: auto;
        }

        .icon {
            width: 10px;
            height: 6px;
            vertical-align: middle;
        }
    }
}

.next {
    width: 100%;
    padding: 0px 32px;
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 142px;
    left: 0;

    .btn {
        width: 100%;
        padding: 15px 0;
        text-align: center;
        background: #5B92FD;
        border-radius: 46px;
        font-size: 18px;
        color: #FFFFFF;
    }

}

.detail {
    width: auto;
    margin: 16px 32px;
    background: #FFFFFF;
    border-radius: 20px;
    color: #333333;
    border-radius: 20px;
    font-size: 14px;
}

.detail .item {
    padding: 16px 32px;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
}


/deep/.van-cell::after {
    border-bottom: 0px !important;
}
</style>
  